<div class="flex items-center justify-between">
  <div #title>{{widgetHeader()}}</div>
</div>
<div class="chart-wrapper">
  <p-chart 
    type="bar" 
    [data]="basicData" 
    [options]="basicOptions"
    class="chart-canvas">
  </p-chart>
</div>